import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bingWebmasters = defineConnector({
  identifier: "bingWebmasters",
  name: "Bing Webmaster Tools",
  tagLine: "Search performance and indexing tools",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () =>
    "https://www\\.bing\\.com/webmaster/api\\.svc/json/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Bing Webmaster Tools app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Bing Webmaster OAuth 2.0 docs](https://learn.microsoft.com/en-us/bingwebmaster/oauth2), sign in to Bing Webmaster Tools, then go to **Settings** → **API Access**. Accept the terms if prompted, click **OAuth Client**, register a client with the redirect URI below, and copy the client ID and client secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/bingWebmasters/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Bing Webmasters account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Bing Webmasters account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://www.bing.com/webmasters/oauth/authorize",
    tokenEndpoint: () => "https://www.bing.com/webmasters/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["webmaster.manage"],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://www.bing.com/webmaster/api.svc/json/GetUserSites",
  },
});
